'use strict';

/**
 * @classname Tab
 * @classdesc タブ
 */
export default class Tab {
	/**
	 * @constructor
	 * @param {jQuery} $e - [data-toggle=tab]
	 */
	constructor($e) {
		console.log(`${this.constructor.name}.constructor`);
		this._$e = $e;
		this._target = $e.attr('data-target');
		this._$target = $(this._target);
		$e.on('click', () => this.onClick());
	};


	/**
	 * clickのコールバック
	 *
	 * @memberof Tab
	 * @return undefined
	 */
	onClick() {
		console.log(`${this.constructor.name}.onClick`);
		if(this._$e.hasClass('active')) return;
		$('.tab__navs__link').removeClass('active').removeClass('btn--primary').addClass('btn--gray').attr('aria-selected', 'false');
		this._$e.addClass('active').removeClass('btn--gray').addClass('btn--primary').attr('aria-selected', 'true');
		$('.tab__content__pane').removeClass('active');
		this._$target.addClass('active');
	};
};
